import { type FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import StatValue from 'app/components/StatValue';

import style from './style.module.scss';

interface Props {
  playerStats: PlayerStatData<any>;
  Icon?: SVG;
  rating?: number;
  teamNumber: 1 | 2;
}

const PlayerStats: FC<Props> = ({ playerStats, Icon, rating, teamNumber }) => {
  const { t } = useTranslation();

  return (
    <li className={classNames(style.playerStatLine, style[`team${teamNumber}`])}>
      <div className={style.playerHeader}>
        <span className={style.playerName}>
          {playerStats.name}
          {Icon && <Icon />}
        </span>
        {rating && <span>{rating}</span>}
      </div>
      <ul className={style.playerStatsList}>
        {playerStats.stats.map((stat, index) => (
          <li key={index} className={style.playerStat}>
            <div className={style.statHeader}>{t(`block-players_stats-${stat.name}`)}</div>
            <div className={style.statValue}>
              <StatValue value={stat.value} displayFunction={stat.displayFunction} />
            </div>
          </li>
        ))}
      </ul>
    </li>
  );
};

PlayerStats.displayName = 'PlayerStats';

export default PlayerStats;
